/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BabylonCovenantCommitteeBTCListInfo } from '../models/BabylonCovenantCommitteeBTCListInfo';
import type { BabylonCovenantCommitteeBtcTrxRequest } from '../models/BabylonCovenantCommitteeBtcTrxRequest';
import type { BabylonCovenantCommitteeDetailInfo } from '../models/BabylonCovenantCommitteeDetailInfo';
import type { BabylonCovenantCommitteeDetailRequest } from '../models/BabylonCovenantCommitteeDetailRequest';
import type { BabylonCovenantCommitteeListInfo } from '../models/BabylonCovenantCommitteeListInfo';
import type { BabylonCovenantCommitteeRequest } from '../models/BabylonCovenantCommitteeRequest';
import type { BabylonCovenantCommitteeSignatureChartListInfo } from '../models/BabylonCovenantCommitteeSignatureChartListInfo';
import type { BabylonCovenantCommitteeSummaryIndicatorInfo } from '../models/BabylonCovenantCommitteeSummaryIndicatorInfo';
import type { CommonEmptyRequest } from '../models/CommonEmptyRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class CovenantCommitteeControllerService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getCovenantCommitteeDetail({
        requestBody,
    }: {
        requestBody: BabylonCovenantCommitteeDetailRequest,
    }): CancelablePromise<BabylonCovenantCommitteeDetailInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/covenant',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getCovenantCommitteeSummary({
        requestBody,
    }: {
        requestBody: CommonEmptyRequest,
    }): CancelablePromise<BabylonCovenantCommitteeSummaryIndicatorInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/covenant/summary',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getCovenantCommitteeList({
        requestBody,
    }: {
        requestBody: BabylonCovenantCommitteeRequest,
    }): CancelablePromise<BabylonCovenantCommitteeListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/covenant/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getCovenantCommitteeSignatureChart({
        requestBody,
    }: {
        requestBody: CommonEmptyRequest,
    }): CancelablePromise<BabylonCovenantCommitteeSignatureChartListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/covenant/chart',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getCovenantCommitteeBtcTrxList({
        requestBody,
    }: {
        requestBody: BabylonCovenantCommitteeBtcTrxRequest,
    }): CancelablePromise<BabylonCovenantCommitteeBTCListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/covenant/btc/trx/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}
